module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('renderer', {
    attrs: {
      "size": _vm.size
    }
  }, [_c('dat-gui', {
    attrs: {
      "setup": _vm.uiSetup,
      "model": _vm.ui
    }
  }), _vm._v(" "), _c('scene', [_c('orbit-controls', {
    attrs: {
      "position": _vm.ui.camera,
      "rotation": {
        x: 2,
        y: 0,
        z: 3
      }
    }
  }, [_c('camera'), _vm._v(" "), _c('audio-listener')], 1), _vm._v(" "), _c('light', {
    attrs: {
      "hex": 0xefefff,
      "intensity": 2,
      "position": {
        x: 50,
        y: 50,
        z: 50
      }
    }
  }), _vm._v(" "), _c('light', {
    attrs: {
      "hex": 0xefefff,
      "intensity": 2,
      "position": {
        x: -50,
        y: -50,
        z: -50
      }
    }
  }), _vm._v(" "), _c('ocean', {
    attrs: {
      "position": _vm.ui.ocean
    }
  }), _vm._v(" "), _c('sf03', {
    attrs: {
      "position": {
        y: 10
      },
      "scale": _vm.ui.sf03.scale
    }
  }), _vm._v(" "), _c('positional-audio', {
    attrs: {
      "position": {
        y: 10
      },
      "url": "static/Project_Utopia.ogg"
    }
  }), _vm._v(" "), _c('movement-system', {
    key: _vm.ui.movemSysKey
  }, [_c('mass-object', {
    attrs: {
      "rv0": {
        x: 2,
        y: 2
      },
      "v0": {
        x: 10
      },
      "f": {
        x: -3,
        y: -2
      },
      "m": 1
    }
  }, [_c('cube', {
    attrs: {
      "texture": "cobblestone",
      "size": 1
    }
  })], 1), _vm._v(" "), _c('mass-object', {
    attrs: {
      "rv0": {
        x: 2,
        z: 2
      },
      "v0": {
        z: 20
      },
      "f": {
        y: -1,
        z: -8
      },
      "m": 1.2
    }
  }, [_c('cube', {
    attrs: {
      "texture": "diamond",
      "size": 1.2
    }
  })], 1), _vm._v(" "), _c('movement-object', {
    attrs: {
      "rv0": {
        x: 2,
        z: 2
      },
      "v0": {
        x: 15,
        z: -20
      },
      "a": {
        x: -6,
        y: .5,
        z: 6
      }
    }
  }, [_c('cube', {
    attrs: {
      "texture": "redwool",
      "size": 1.1
    }
  })], 1)], 1), _vm._v(" "), _c('oimo-world', {
    attrs: {
      "options": {
        gravity: [0, 1, 0]
      }
    }
  }, [_c('space-system', {
    attrs: {
      "m-scale": Math.pow( 10, 4 )
    }
  }, _vm._l((_vm.textures), function(t) {
    return _c('space-object', {
      key: t
    }, [_c('oimo-body', {
      attrs: {
        "options": {
          move: true,
          density: 1
        }
      }
    }, [_c('cube', {
      attrs: {
        "texture": t,
        "size": 1
      }
    })], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-314f2758","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/App.vue
// module id = 161
// module chunks = 1